/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prettier/prettier */
import React, { useEffect } from 'react';

export function GetTableFooter(
  activeNumber: number = 0,
  totalNumber: number = 0,
  changePage: (page: number) => void,
  buttonText: string = '',
  buttonLink: () => void,
  visableButton: boolean = false
) {
  useEffect(() => {}, []);
  const nowPage: number = Math.floor((activeNumber + 9) / 10);
  const pageNum = () => {
    const ret = [];

    for (let i: number = 10 * nowPage - 9; i <= 10 * nowPage && i <= totalNumber; i++) {
      ret.push(
        <a
          href="#"
          key={Math.random()}
          onClick={() => {
            changePage(i);
          }}
          className={`${i === activeNumber ? 'active' : ''}`}
        >
          {i}
        </a>
      );
    }
    return ret;
  };

  return (
    <div className="table-footer">
      {totalNumber === 0 ? (
        <div className="pagenation">
          <span>결과가 없습니다.</span>
        </div>
      ) : (
        <div className="pagenation">
          <a
            href="#"
            onClick={() => {
              changePage(
                (nowPage - 1) * 10 - 1 < 1 ? 1 : Math.min((nowPage - 1) * 10, totalNumber)
              );
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </a>
          <a
            href="#"
            onClick={() => {
              changePage(activeNumber - 1 < 1 ? 1 : activeNumber - 1);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </a>
          {pageNum()}
          <a
            href="#"
            onClick={() => {
              changePage(activeNumber + 1 > totalNumber ? totalNumber : activeNumber + 1);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            </svg>
          </a>
          <a
            href="#"
            onClick={() => {
              changePage(nowPage * 10 + 1 > totalNumber ? totalNumber : nowPage * 10 + 1);
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            </svg>
          </a>
        </div>
      )}
      {visableButton && totalNumber !== 0 ? (
        <div className="buttons">
          <button
            type="button"
            className="btn-main"
            onClick={() => {
              buttonLink();
            }}
          >
            {buttonText}
          </button>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
